module.exports = __webpack_public_path__ + "static/media/siddharth-yelahanka-trip-03.bcb44bc0.png";